import { Link } from 'react-router-dom';
import Reveal from '@/components/base/Reveal';
import SectionHeading from '@/components/base/SectionHeading';
import ArticleCard from '@/components/feature/ArticleCard';
import { articles } from '@/mocks/articles';

export default function LatestSection() {
  const latest = [...articles]
    .sort((a, b) => (a.date < b.date ? 1 : -1))
    .slice(0, 6);

  return (
    <section className="mx-auto w-full max-w-7xl px-4 py-16 md:px-6 md:py-20">
      <SectionHeading
        eyebrow="Latest"
        title="最新观察"
        desc="持续更新中的文化摩擦案例整理，每条都附上背景与你可能忽略的另一面。"
        action={
          <Link
            to="/topics"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            全部文章
            <i className="ri-arrow-right-line"></i>
          </Link>
        }
      />

      <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {latest.map((item, index) => (
          <Reveal key={item.slug} delay={index * 60}>
            <ArticleCard article={item} />
          </Reveal>
        ))}
      </div>
    </section>
  );
}